<template>
  <div id="app">
    <div v-if="routerIsLoading" class="spinner-overlay">
      <div class="spinner"></div>
    </div>
    <router-view />
    <phoneNumberPromptModal
      v-if="needsPhoneNumber"
      @saved="phonePromptDismissed = true"
      @dismiss="phonePromptDismissed = true"
    />
  </div>
</template>
<script>
import phoneNumberPromptModal from "@/components/user/Phone_Number_Prompt_Modal.vue";

export default {
  components: {
    phoneNumberPromptModal,
  },
  data() {
    return {
      isLoading: false,
      // Reset on every reload, so the prompt reappears next session until a
      // phone number is on file, but does not nag after a "Maybe later".
      phonePromptDismissed: false,
    };
  },
  computed: {
    routerIsLoading() {
      return this.$store.getters.routerIsLoading;
    },
    account() {
      return this.$store.getters.account.data;
    },
    // Prompt signed-in users (incl. fresh logins, sign-ups and Google sign-ins)
    // whose account has no phone number yet.
    needsPhoneNumber() {
      return Boolean(this.account) && !this.account.phoneNumber && !this.phonePromptDismissed;
    },
  },
};
</script>

<style lang="css">
@import "./assets/style/index.css";

.spinner-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.spinner {
  position: relative;
  width: 140px;
  height: 140px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.spinner::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 4px solid rgba(13, 18, 57, 0.08);
  border-radius: 50%;
  border-left-color: var(--ehs-color-primary);
  animation: spin 1s linear infinite;
}

.spinner img {
  height: 60px;
  z-index: 10; /* Ensures the image is above the spinner */
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
